import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=19b38b66&scoped=true&"
import script from "./avatar.js?vue&type=script&lang=js&"
export * from "./avatar.js?vue&type=script&lang=js&"
import style0 from "./avatar.scss?vue&type=style&index=0&id=19b38b66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b38b66",
  null
  
)

export default component.exports